export const navItems = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Projects', href: '/projects' },
//    { name: 'Resume', href: '/resume' },
    { name: 'How Tos', href: '/how-tos' },
    { name: 'Opinions', href: '/opinions' },
    { name: 'Contact', href: '/contact' },
  ]
  
  